import {inject, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationStatus, DeleteConfirmationParams} from '../types/confirmation-modal.types';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  private dialog: MatDialog = inject(MatDialog);

  constructor() { }

  public getDeleteConfirmation(deleteConfirmationParams: DeleteConfirmationParams): Promise<boolean> {
    return new Promise(resolve => {
      const dialogRef = this.dialog.open(deleteConfirmationParams.component, {
        data: {deleteConfirmationParams}
      });

      dialogRef.afterClosed().subscribe((status: ConfirmationStatus) => {
        resolve(status === 'remove');
      })
    });
  }
}
